import SystemUpdate from '@/views/SystemUpdate.vue';

import getDeviceInfo from '@/lib/base/getDeviceInfo';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

import verification from '@/router/routes/verification';
import tournament from '@/router/routes/tournament';
import practice from '@/router/routes/practice';
import pvp from '@/router/routes/pvp';
import personal from '@/router/routes/personal';
import course from '@/router/routes/course';
import teacherManagement from '@/router/routes/teacher-management';
import aiTutor from '@/router/routes/ai-tutor';
import aiCourse from '@/router/routes/ai-course';
import multimediaClassroom from '@/router/routes/multimedia-classroom';
import ladder from '@/router/routes/ladder';
import weeklyTsume from '@/router/routes/weekly-tsume';
import studentManagement from '@/router/routes/student-management';
import cardgolegends from '@/router/routes/cardgolegends';
import products from '@/router/routes/products';
import localeConfigs from '@/config/locale.js';
import {getLocale} from '@/i18n/utils.js';

const routes = [
  // {
  //   path: '*',
  //   redirect: '/',
  // },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () => import('@/views/TermsOfService.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('@/views/Login/Signup.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  {
    path: '/signup-status',
    name: 'signup-status',
    component: () => import('@/views/Login/SignupStatus.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
      depth: 1,
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => import('@/views/Login/ForgetPassword.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/Login/ResetPassword.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/views/Notification/NotificationList.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: false,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/serial-number',
    name: 'serial-number',
    component: () => import('@/views/Login/SerialNumber.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
    },
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      depth: 1,
    },
  },
  {
    path: '/video',
    name: 'video',
    component: () => import('@/views/Home.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      depth: 1,
    },
  },
  {
    path: '/language',
    name: 'language',
    component: () => import('@/views/Language/index.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
      transitionDepth: 3,
    },
  },
  {
    path: '/roomSetting',
    name: 'roomSetting',
    component: () => import('@/views/Personal/RoomSetting.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      fromUpperTransitionType: 'slide',
      toUpperTransitionType: 'slide',
    },
  },
  {
    path: '/live/list',
    name: 'liveList',
    component: () => import('@/views/Live/LiveList.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      depth: 1,
    },
  },
  {
    path: '/live/end',
    name: 'live-end',
    component: () => import('@/views/Live/LiveEnd.vue'),
    meta: {
      hasNavigation: false,
      noLandscapeReminder: true,
    },
  },
  {
    path: '/live/manage',
    name: 'live-manage',
    component: () => import('@/views/Live/LiveManage.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
    },
  },
  {
    path: '/live/manage/quota-record',
    name: 'live-quota-record',
    component: () => import('@/views/Live/LiveQuotaRecord.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
    },
  },
  {
    path: '/no-lesson/:type',
    name: 'no-lesson',
    component: () => import('@/views/NoLesson.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
    },
  },
  {
    path: '/more-about-courses',
    name: 'more-about-courses',
    component: () => import('@/views/MoreAboutCourses/index.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
    },
  },
  {
    path: '/systemUpdate',
    name: 'systemUpdate',
    component: SystemUpdate,
    meta: {
      hasNavigation: false,
      requireAuth: false,
    },
  },
  {
    path: '/more',
    name: 'more',
    component: () => import('@/views/More.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
    },
  },
  {
    path: '/learning',
    redirect: '/learning/course',
  },
  {
    path: '/learning/:mode',
    name: 'learningPage',
    component: () => import('@/views/LearnPage.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
    },
  },
  {
    path: '/camera-to-score-game',
    name: 'cameraToScoreGame',
    component: () => import('@/views/Cardgolegends/CameraToScoreGame.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
    },
  },
  {
    path: '/go-robot',
    name: 'goRobot',
    component: () => import('@/views/GoRobot/index.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
    },
  },
  {
    path: '/real-time-board/:boardId',
    name: 'real-time-board',
    component: () => import('@/views/RealTimeBoard/index.vue'),
    meta: {},
  },
  ...teacherManagement,
  ...verification,
  ...tournament,
  ...practice,
  ...pvp,
  ...personal,
  ...course,
  ...aiTutor,
  ...aiCourse,
  ...multimediaClassroom,
  ...ladder,
  ...weeklyTsume,
  ...studentManagement,
  ...cardgolegends,
  ...products,
];

export default [
  {
    path: '/',
    redirect: () => {
      return `/${getLocale()}`;
    },
  },
  {
    path: `/:pathMatch(${localeConfigs.map((l) => l.code).join('|')})`,
    component: () => import('@/views/localeRouterPage.vue'),
    children: routes.map((route) => {
      let path = route.path;
      if (path.indexOf('/') === 0) {
        path = path.replace('/', '');
      }
      return {
        ...route,
        path,
      };
    }),
  },
  {
    path: '/*',
    redirect: (to) => {
      return `/${getLocale()}${to.path}`;
    },
  },
];
